/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_ppi_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How is PPI calculated?`)
};

const es_ppi_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Cómo se calcula el PPI?`)
};

const de_ppi_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wie wird PPI berechnet?`)
};

const nl_ppi_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hoe wordt PPI berekend?`)
};

const fr_ppi_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comment le PPP est-il calculé ?`)
};

const it_ppi_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Come si calcola il PPI?`)
};

const pt_br2_ppi_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como o PPI é calculado?`)
};

const pt_ppi_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Como é calculado o PPI?`)
};

const ja_ppi_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPIはどう計算されますか?`)
};

const zh_ppi_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PPI 是如何计算的？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const ppi_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.ppi_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("ppi_faq_q2", locale)
	if (locale === "en") return en_ppi_faq_q2(inputs)
	if (locale === "es") return es_ppi_faq_q2(inputs)
	if (locale === "de") return de_ppi_faq_q2(inputs)
	if (locale === "nl") return nl_ppi_faq_q2(inputs)
	if (locale === "fr") return fr_ppi_faq_q2(inputs)
	if (locale === "it") return it_ppi_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_ppi_faq_q2(inputs)
	if (locale === "pt") return pt_ppi_faq_q2(inputs)
	if (locale === "ja") return ja_ppi_faq_q2(inputs)
	return zh_ppi_faq_q2(inputs)
};